const defaultZoomSize = 20

const maps = {
    defaultZoomSize,
}

export default maps